import React from 'react';
import { TEST_TYPE0 } from '../entry-points/entry';
import styled, { createGlobalStyle } from 'styled-components'
import { SvgRightAngle } from './svg'

const tTags = ['relo-club', 'benefit', 'genovision'];

const ButtonContainer = styled.div`
  display: grid;
  gap: 1rem;
  margin-top: 2rem;

  @media (max-width: 40rem){
  }
`

const Button = styled.div`
  padding: 1rem 2rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: center;
  color: white;
  line-height: 1.5;
  display: grid;
  height: 3rem;
  align-items: center;
  text-align: center;
  border-radius: 0.5rem;
  position: relative;
  transition: background-color 0.4s;
  background-color: var(--background-color);
  svg {
    display: block;
    height: 1.5rem;
    width: auto;
    position: absolute;
    right: 1rem;
    top: 0;
    bottom: 0;
    margin-block: auto;
  }
`

const CommonButton = styled(Button)`
  --background-color: #e35151;
  &:hover {
    background-color: color-mix(in srgb, var(--background-color) 50%, white);
  }
`

const OtherButton = styled(Button)`
  --background-color: #0081BB;
  &:hover {
    background-color: color-mix(in srgb, var(--background-color) 50%, white);
  }
`

const HideBanner = createGlobalStyle`
  .ftbn {
    display: none;
  }
`

const Text = styled.div`
  line-height: 1.5;
  font-size: 0.835rem;
`

const List = styled.div`
  line-height: 1.5;
  font-size: 0.835rem;
`

export function SelectTestType0({ onNext, testType0State }: { onNext: () => void; testType0State: any;}) {
  const next = (v: TEST_TYPE0) => {
    testType0State[1](v)
  }
  return <>
    <HideBanner />
    <h3 style={{ fontSize: '1.5rem', marginBottom: '0' }}>メタロ・バランス検査お申し込み</h3>
    <ButtonContainer>
      <CommonButton onClick={() => next('common')}>
        一般のお申し込みの方
        <SvgRightAngle size={18} strokeWidth={3}/>
      </CommonButton>
      <OtherButton onClick={() => next('other')}>
        MBコード(クーポンコード)をお持ちの方<br />
        ご紹介・各種会員・社員の方
        <SvgRightAngle size={18} strokeWidth={3}/>
      </OtherButton>
    </ButtonContainer>
    <h3>必ずお読みください「メタロ・バランス検査の対象者」</h3>
    <Text>がんリスク検査は20歳～80歳、認知リスク検査は50歳～80歳の日本人を対象として開発されています。対象外の年齢の方がこの検査を受けられた場合の結果は参考となることをご理解ください。</Text>
    <Text>また、以下の方はメタロ・バランス検査では判定が困難であるため、検査申込はお控えください。</Text>
    <List>
      <li>妊娠中または出産後6ヶ月未満の方</li>
      <li>がん治療中の方、がん治療終了後1年未満の方</li>
      <li>透析を受けている方</li>
      <li>骨折、血液疾患、免疫不全症の方（中性脂肪等による脂質異常症は含まない）</li>
      <li>体調不良の方（睡眠不足、徹夜明け、激しい運動後、ストレス等や、風邪、喘息、帯状疱疹、アレルギー性発疹・鼻炎などの症状がある場合）</li>
    </List>
    <Text>※検査日当日の無断キャンセルは、検査料の30％をご請求させていただきますのでご了承願います。詳細は<a href="/faq/" target="_blank" rel="noopener noreferrer">こちら</a>をご参照ください。</Text>

    <h3>メタロ・バランス検査申し込みの流れ</h3>
    <ol className="entry-flow">
      <li><p>検査申し込み画面より申し込み</p></li>
      <li><p>株式会社レナテックより検査関係書類を検査日の1週間前までに送付</p></li>
      <li><p>指定日時・場所で採血（検査関係書類は当日お持ち下さい）</p></li>
      <li><p>検査料の支払い（検査後3週間程でコンビニ払いハガキを送付）</p></li>
      <li><p>検査報告書ご自宅宛送付（採血から報告まで5週間程度）</p></li>
    </ol>
  </>;
}
